import React, { useState, useMemo } from 'react';
import { Box, Button, Typography, Tooltip } from '@mui/material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config/appConfig';
import { useDispatch, useSelector } from 'react-redux';
import { getUserNotifications } from '../../common/Redux/Reducer';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import AssignmentIndRoundedIcon from '@mui/icons-material/AssignmentIndRounded';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import DirectionsRunRoundedIcon from '@mui/icons-material/DirectionsRunRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import GroupAddRoundedIcon from '@mui/icons-material/GroupAddRounded';
import EventBusyRoundedIcon from '@mui/icons-material/EventBusyRounded';
import MarkEmailReadRoundedIcon from '@mui/icons-material/MarkEmailReadRounded';
import { jwtDecode } from 'jwt-decode';
import moment from "moment";
import Drawer from '@mui/joy/Drawer';
import Badge from '@mui/material/Badge';
import Skeleton from '@mui/material/Skeleton';
import './notificationdrawer.scss';

const truncateText = (text, wordLimit) => {
    const words = text.split(' ');
    if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(' ') + '...';
    }
    return text;
};

/* the signed-in user, read straight off the token the same way the rest of
   this component does — kept in one place so a bad token cannot throw */
const readEmail = () => {
    try {
        const token = localStorage.getItem('accessToken');
        return token ? (jwtDecode(token)?.email || '') : '';
    } catch (error) {
        return '';
    }
};

/* titles are free text, so the icon is a hint rather than a type: a bell is
   always a correct fallback */
const NOTIF_ICONS = [
    { match: /assign|owner/i, icon: <AssignmentIndRoundedIcon /> },
    { match: /comment|mention|repl/i, icon: <ChatBubbleOutlineRoundedIcon /> },
    { match: /sprint/i, icon: <DirectionsRunRoundedIcon /> },
    { match: /done|complete|closed|resolved/i, icon: <TaskAltRoundedIcon /> },
    { match: /due|overdue|expire/i, icon: <EventBusyRoundedIcon /> },
    { match: /invite|added|member|people|project/i, icon: <GroupAddRoundedIcon /> },
];

const iconFor = (title = '') => {
    const hit = NOTIF_ICONS.find(({ match }) => match.test(title));
    return hit ? hit.icon : <NotificationsActiveOutlinedIcon />;
};

/* "Today" / "Yesterday" / a date — the list reads as a timeline instead of a
   flat stack of cards */
const dayLabel = (date) => {
    const when = moment(date);
    if (!when.isValid()) return 'Earlier';
    if (when.isSame(moment(), 'day')) return 'Today';
    if (when.isSame(moment().subtract(1, 'day'), 'day')) return 'Yesterday';
    if (when.isAfter(moment().subtract(7, 'days'))) return when.format('dddd');
    return when.format('MMM D, YYYY');
};

const NotificationComponent = () => {
    const [open, setOpen] = useState(false);
    const [filter, setFilter] = useState('unread');

    const dispatch = useDispatch();
    const [usreNotifications, setUserNotifications] = useState([])
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const { user } = useSelector((state) => {
        return state.ProjamAppSlice;
    });
    // the API can answer with a non-list (an error body, say); .map on that took the whole app down
    let userNotifications = Array.isArray(user?.notifications) ? user.notifications : []
    const [loading, setLoading] = useState(false)
    // let decoded = {}

    /* counts come from the store, not from the filtered list, so the bell badge
       and the tabs stay right whichever tab is open */
    const { unreadCount, allCount } = useMemo(() => {
        const email = readEmail();
        const mine = (Array.isArray(user?.notifications) ? user.notifications : []).filter(
            (each) => each?.receivers?.some((receiverObj) => receiverObj?.receiver === email)
        );
        return {
            allCount: mine.length,
            unreadCount: mine.filter((each) =>
                each?.receivers?.some(
                    (receiverObj) => receiverObj?.receiver === email && receiverObj?.read === false
                )
            ).length,
        };
    }, [user?.notifications]);

    /* the filter keeps each match wrapped in its own array; flatten once here so
       the list can be sorted and grouped */
    const visible = useMemo(() => {
        return (usreNotifications || [])
            .map((each) => (Array.isArray(each) ? each[0] : each))
            .filter(Boolean)
            .sort((a, b) => moment(b?.createdAt).valueOf() - moment(a?.createdAt).valueOf());
    }, [usreNotifications]);

    const groups = useMemo(() => {
        const out = [];
        visible.forEach((item) => {
            const label = dayLabel(item?.createdAt);
            const last = out[out.length - 1];
            if (last && last.label === label) last.items.push(item);
            else out.push({ label, items: [item] });
        });
        return out;
    }, [visible]);

    useEffect(() => {
        getNotificatoins()
        //   let token = localStorage.getItem('accessToken');
        //   if (token) {
        //     decoded = jwtDecode(token)
        //   }

    }, [])


    const getNotificatoins = async () => {
        setLoading(true)
        try {
            let notifications = await dispatch(getUserNotifications())
            setLoading(false);
        }
        catch (error) {
            console.log(error)
            setLoading(false);
        }
    }

    useEffect(() => {
        filterNotifications()
    }, [userNotifications, filter])

    const filterNotifications = () => {
        setLoading(true)
        let decoded = {}
        let token = localStorage.getItem('accessToken');
        if (token) {
            decoded = jwtDecode(token)
        }

        if (filter == 'unread') {

            let filteredNotifications = userNotifications?.map((notificationobj) => {

                let req = []
                let filterNotifications = notificationobj?.receivers?.some((receiverObj) => {
                    if (receiverObj?.receiver == `${decoded?.email}` && receiverObj?.read == false) {
                        req.push(notificationobj)
                    }
                })
                return req
            })
            filteredNotifications = filteredNotifications?.filter((each) => each?.length)

            setUserNotifications(filteredNotifications)
        }
        if (filter == 'all') {

            let filteredNotifications = userNotifications?.map((notificationobj) => {

                let req = []
                let filterNotifications = notificationobj?.receivers?.some((receiverObj) => {
                    if (receiverObj?.receiver == `${decoded?.email}`) {
                        req.push({
                            ...notificationobj,
                            isUnread: receiverObj?.read === false,
                        });
                    }
                });
                return req
            })
            filteredNotifications = filteredNotifications?.filter((each) => each?.length)
            setUserNotifications(filteredNotifications)
        }
        setLoading(false)
    }


    const updateReadStatus = async (id) => {
        setLoading(true)
        let decoded = {}
        let token = localStorage.getItem('accessToken');
        if (token) {
            decoded = jwtDecode(token)
        }
        try {
            let updateReadStatus = await axios.post(`${API_BASE_URL}/notification/updateReadstatus`,
                {
                    notificationId: id,
                    Email: `${decoded.email}`
                }
            )
            setLoading(false)
            filterNotifications()
            getNotificatoins()
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    return (
        <div>
            {/* round bell button, styled with the top bar (topbar.scss .tb-icon-btn / .tb-bell) */}
            <button
                type="button"
                className="tb-icon-btn tb-bell"
                aria-label={unreadCount > 0 ? `Notifications, ${unreadCount} unread` : 'Notifications'}
                onClick={() => {
                    setOpen(true);
                    setFilter('unread');
                    filterNotifications();
                }}
            >
                <Badge
                    badgeContent={unreadCount > 0 ? unreadCount : null}
                    color="error"
                    overlap="circular"
                    className="tb-badge"
                >
                    <NotificationsNoneIcon />
                </Badge>
            </button>

            <Drawer open={open} onClose={() => {
                setOpen(false);
                setFilter('unread');
            }}
                anchor="right"
                className='notification-drawer-cls'
            >
                <header className="pj-nd-head">
                    <span className="pj-nd-tile" aria-hidden="true">
                        <NotificationsRoundedIcon />
                    </span>
                    <div className="pj-nd-heading">
                        <h2>Notifications</h2>
                        <p>
                            {unreadCount > 0
                                ? `${unreadCount} unread ${unreadCount === 1 ? 'update' : 'updates'} for you`
                                : "You're all caught up"}
                        </p>
                    </div>
                    <Tooltip title="Close">
                        <button
                            type="button"
                            className="pj-nd-close"
                            aria-label="Close"
                            onClick={() => {
                                setOpen(false);
                                setFilter('unread');
                            }}
                        >
                            <CloseRoundedIcon />
                        </button>
                    </Tooltip>
                </header>

                <Box className='pj-nd-tabs' role="tablist">
                    <Button
                        onClick={() => setFilter('unread')}
                        variant="text"
                        role="tab"
                        aria-selected={filter === 'unread'}
                        className={`pj-nd-tab ${filter === 'unread' ? 'is-active' : ''}`}
                    >
                        Unread
                        {unreadCount > 0 ? <span className="pj-nd-count">{unreadCount}</span> : null}
                    </Button>
                    <Button
                        onClick={() => setFilter('all')}
                        variant="text"
                        role="tab"
                        aria-selected={filter === 'all'}
                        className={`pj-nd-tab ${filter === 'all' ? 'is-active' : ''}`}
                    >
                        All
                        {allCount > 0 ? <span className="pj-nd-count">{allCount}</span> : null}
                    </Button>
                </Box>

                <div className='pj-nd-list'>
                    {loading ? (
                        [...Array(6)].map((_, index) => (
                            <Box key={index} className="pj-nd-card is-skeleton">
                                <Skeleton variant="circular" width={38} height={38} />
                                <Box sx={{ flex: 1 }}>
                                    <Skeleton width="55%" height={18} />
                                    <Skeleton width="85%" height={15} />
                                </Box>
                            </Box>
                        ))
                    ) : groups.length ? (
                        groups.map((group, groupIndex) => (
                            <section className="pj-nd-group" key={group.label}>
                                <h3 className="pj-nd-group__label">{group.label}</h3>
                                {group.items.map((notification, index) => {
                                    const unread = notification?.isUnread || filter === 'unread';
                                    return (
                                        <Box
                                            key={notification._id}
                                            className={`pj-nd-card ${unread ? 'is-unread' : ''}`}
                                            style={{ '--d': `${Math.min(groupIndex * 60 + index * 40, 320)}ms` }}
                                            role="button"
                                            tabIndex={0}
                                            onKeyDown={(event) => {
                                                if (filter === 'unread' && (event.key === 'Enter' || event.key === ' ')) {
                                                    event.preventDefault();
                                                    updateReadStatus(notification._id);
                                                }
                                            }}
                                            onClick={() => {
                                                if (filter === 'unread') {
                                                    updateReadStatus(notification._id)
                                                }
                                            }}
                                        >
                                            <span className="pj-nd-icon" aria-hidden="true">
                                                {iconFor(notification?.notification?.title)}
                                            </span>
                                            <div className="pj-nd-text">
                                                <div className="pj-nd-row">
                                                    <Typography variant="body1" className="pj-nd-title">
                                                        {notification?.notification?.title}
                                                    </Typography>
                                                    <Tooltip
                                                        title={moment(notification?.createdAt).format('MMM D, YYYY · hh:mm A')}
                                                    >
                                                        <Typography component="span" className="pj-nd-time">
                                                            {moment(notification?.createdAt).fromNow()}
                                                        </Typography>
                                                    </Tooltip>
                                                </div>
                                                <Typography variant="body2" className="pj-nd-body">
                                                    {notification?.notification?.body}
                                                </Typography>
                                                {unread ? (
                                                    <span className="pj-nd-hint">
                                                        <MarkEmailReadRoundedIcon />
                                                        Click to mark as read
                                                    </span>
                                                ) : null}
                                            </div>
                                            {unread ? <span className="pj-nd-dot" aria-label="Unread" /> : null}
                                        </Box>
                                    );
                                })}
                            </section>
                        ))
                    ) : (
                        <div className="pj-nd-empty">
                            <span className="pj-nd-empty__art" aria-hidden="true">
                                <TaskAltRoundedIcon />
                            </span>
                            <strong>{filter === 'unread' ? 'No unread notifications' : 'Nothing here yet'}</strong>
                            <p>
                                {filter === 'unread'
                                    ? 'Everything is read. New updates will land here.'
                                    : 'Updates about your issues and sprints will appear here.'}
                            </p>
                            {filter === 'unread' && allCount > 0 ? (
                                <Button className="pj-nd-empty__btn" onClick={() => setFilter('all')}>
                                    View all notifications
                                </Button>
                            ) : null}
                        </div>
                    )}
                </div>
            </Drawer>

        </div>
    );
};

export default NotificationComponent;
